import { FC, useCallback } from 'react';
import { DeviceShadowFeature } from 'models';
import Accordion from 'components/UI/Accordion';
import AccordionItem from 'components/UI/Accordion/AccordionItem';
import { useAccess } from 'hooks/useAccess';

type Props = {
  shadows: DeviceShadowFeature[];
  selectedFeatureSpecification?: string;
};

const ShadowTree: FC<Props> = ({ shadows, selectedFeatureSpecification }) => {
  const { setDesiredAccess } = useAccess();

  const getAccordionItems = useCallback(
    (myShadows: DeviceShadowFeature[]) => {
      if (!myShadows) {
        return null;
      }
      return myShadows?.map(
        ({
          title,
          children,
          value,
          writable,
          modified,
          desired,
          totalDesiredCount,
        }) => {
          const isWritable = setDesiredAccess ? writable : false;

          if (children) {
            return (
              <AccordionItem
                key={title}
                title={title}
                modified={modified}
                writable={isWritable}
                desired={desired}
                totalDesiredCount={totalDesiredCount}
                shadows={myShadows}
                selectedFeatureSpecification={selectedFeatureSpecification}
              >
                {getAccordionItems(children)}
              </AccordionItem>
            );
          }
          return (
            <AccordionItem
              modified={modified}
              key={title}
              title={title}
              writable={isWritable}
              desired={desired}
              totalDesiredCount={totalDesiredCount}
              shadows={myShadows}
              value={JSON.stringify(value)}
              selectedFeatureSpecification={selectedFeatureSpecification}
            />
          );
        }
      );
    },
    [selectedFeatureSpecification, setDesiredAccess]
  );

  return (
    <div className="shadowTree">
      <Accordion>{getAccordionItems(shadows)}</Accordion>
    </div>
  );
};

export default ShadowTree;
